module.exports = __webpack_public_path__ + "assets/graphql.b1089cac.svg";